//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    //A boolean option is the default
    options: {
      type: Object,
      "default": function _default() {
        return {
          "true": true,
          "false": false
        };
      }
    },
    value: {
      "default": true
    }
  },
  created: function created() {
    this.$store.commit('elements/setDefaultOption', {
      name: this.name,
      value: this.value
    });
  },
  computed: {
    selected: {
      get: function get() {
        return this.$store.state.elements.globalOptions[this.name];
      },
      set: function set(v) {
        this.$store.commit('elements/setGlobalOption', {
          name: this.name,
          value: v
        });
      }
    }
  }
};